<template>
  <div class="app-container">
    <!-- 顶部菜单栏 -->
    <TopMenu />

    <div class="main-content">
      <!-- 左侧菜单栏 -->
      <SideMenu @menu-click="handleMenuClick" />

      <!-- 右侧动态内容 -->
      <div class="content-area">
        <DynamicContent :component="currentComponent" />
      </div>
    </div>
    <!-- 底部备案信息 -->
    <div class="footer">
      <p>© 2025 个人版权所有 | 备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2024353179号-2</a></p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import TopMenu from '../components/TopMenu.vue'
import SideMenu from '../components/SideMenu.vue'
import DynamicContent from '../components/DynamicContent.vue'
import IndexView from './IndexView.vue'

export default {
  components: {
    TopMenu,
    SideMenu,
    DynamicContent
  },
  setup() {
    const currentComponent = ref(IndexView)

    const handleMenuClick = (component) => {
      currentComponent.value = component
    }

    return {
      currentComponent,
      handleMenuClick
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #3b82f6;
  transition: all 0.3s ease;
}

a:hover {
  color: #2563eb;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f7f9fc;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.content-area {
  flex: 1;
  width: 85%;
  overflow-y: auto;
  background-color: #ffffff;
}

/* 底部备案信息样式 */
.footer {
  height: 40px;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #64748b;
}

/* 顶部工具栏：浅色简约 */
:deep(.top-menu) {
  background-color: #ffffff !important;
  border-bottom: 1px solid #e5e7eb;
  color: #0f172a !important;
}

:deep(.top-menu .title) {
  color: #0f172a !important;
}

:deep(.top-menu .menu-items button) {
  color: #3b82f6 !important;
}

:deep(.top-menu .menu-items button:hover) {
  color: #2563eb !important;
}

/* 左侧导航：浅灰蓝底 + 蓝色激活态 */
:deep(.side-menu) {
  background-color: #f1f5f9 !important;
  border-right: 1px solid #e2e8f0;
  color: #334155 !important;
}

:deep(.side-menu li:hover) {
  background-color: #e2e8f0 !important;
}

:deep(.side-menu li.active) {
  background-color: #dbeafe !important;
  color: #1d4ed8 !important;
}
</style>